<lib-form-field-container
    #anchor
    [isOptional]="isOptional"
    [kind]="FormContainerKind.Text"
    [hideErrors]="autocomplete ? autocomplete.panelOpen : false"
    (fieldClicked)="Clicked($event)">

    <ng-content label select="[label]"></ng-content>
    <ng-content supportingText select="[supportingText]"></ng-content>
    <ng-content prefixText select="[prefixText]"></ng-content>
    <ng-content suffixText select="[suffixText]"></ng-content>
    <ng-content menu select="[menu]"></ng-content>
    <ng-content bottomMenu select="[bottomMenu]"></ng-content>
    <ng-container readOnly>
        <div class="wrapper-content" #providedReadOnly>
            <ng-content select="[readOnly]"></ng-content>
        </div>
        <div class="default-content">{{ formControl.value }}</div>
    </ng-container>

    @if (!isLoading && !isReadOnly) {
        <input #input
            [id]="formFieldID"
                        [attr.aria-describedby]="formFieldID + '-description ' + formFieldID + '-error'"
                                                [attr.aria-label]="ariaLabel || null"
                                                [attr.aria-invalid]="formControl.isDirty && formControl.errors ? 'true' : null"
                        [attr.aria-required]="formControl.isRequired"
            [placeholder]="placeholderText"
            [formControl]="viewControl"
            [matAutocomplete]="auto"
            [matAutocompleteConnectedTo]="anchor?.origin!"
            [attr.data-sb-qa]="qaTag"
            (change)="$event.stopPropagation()"
            >
        <mat-autocomplete
            #auto="matAutocomplete"
            (optionSelected)="Selected($event)"
            (closed)="PanelClosed($event)">
            @for (groupItems of filteredItemsByGroup | async | keyvalue: keepOrder; track groupItems.key) {
                @if (!groupItems.key) {
                    @for (item of groupItems.value; track item.value) {
                        <mat-option [value]="identifierOf(item.value)">
                            <ng-container *ngTemplateOutlet="panelItem; context: { $implicit: item }"></ng-container>
                        </mat-option>
                    }
                } @else if (groupItems.value.length) {
                    <mat-optgroup
                        class="select-text"
                        [label]="groupItems.key.name">
                        @for (item of groupItems.value; track item.value) {
                            <mat-option [value]="identifierOf(item.value)">
                                <ng-container *ngTemplateOutlet="panelItem; context: { $implicit: item }"></ng-container>
                            </mat-option>
                        }
                    </mat-optgroup>
                }
            }
        </mat-autocomplete>
    }
</lib-form-field-container>

<ng-template
    #panelItem
    let-item>
    <div class="sb-panel-item-wrapper">
        <ng-container *ngTemplateOutlet="item.selectLabel"></ng-container>
        <small #caption [hidden]="!caption.textContent?.trim()"><ng-container *ngTemplateOutlet="item.selectSupportingText"></ng-container></small>
    </div>
</ng-template>
